export default __webpack_public_path__ + "static/media/NMG.560ec795.svg";